














import { PriceDisplayHelper } from "@/chipply/helper/PriceDisplayHelper";
import IPriceDisplay from "@/chipply/interface/IPriceDisplay";
import Vue from "vue";
import Component from "vue-class-component";
import { Inject, Prop } from "vue-property-decorator";

@Component({})
export default class PriceDisplay extends Vue {
    public name = "PriceDisplay";
    private priceDisplayHelper = new PriceDisplayHelper();

    @Prop({ type: Number })
    public price!: number;

    @Prop({ type: Function })
    public dollarDisplayFunc?: (value: number) => string;

    @Prop({ type: Boolean })
    public highlightFirst!: boolean;

    @Prop({ type: Boolean })
    public bold!: boolean;

    @Prop({ type: String, default: "#6E6E70" })
    public secondaryColor!: string;

    @Inject()
    private priceDisplay!: IPriceDisplay;

    public get displayPriceParts() {
        if (!this.priceDisplay) {
            return [];
        }
        const valueDisplay = this.dollarDisplayFunc ? this.dollarDisplayFunc(this.price) : undefined;
        const prices = this.priceDisplayHelper.getPriceDisplay(this.price, this.priceDisplay, valueDisplay);
        return prices;
    }

    public getPartClasses(index: number) {
        if (this.bold) {
            return {
                "font-weight-bold": this.highlightFirst && index === 0,
                "font-weight-medium": this.highlightFirst && index !== 0,
            };
        }
    }
}
